export default "__VITE_PUBLIC_ASSET__db752a0d__"